import { connectToStores } from 'fluxible-addons-react';
import { QUANTUM_UI } from '../../../../flags';
import StaticContentStore from '../../../stores/StaticContentStore';
import { StaticPage } from './StaticPage';
import { StaticPage as StaticPageOld } from './StaticPage.old';
var StaticPageComponent = QUANTUM_UI ? StaticPage : StaticPageOld;
export default connectToStores(StaticPageComponent, [StaticContentStore], function (context, props) {
    var staticContentStore = context.getStore(StaticContentStore);
    return {
        url: props.currentRoute.url,
        content: staticContentStore.getContent(),
    };
});
